module.exports = __webpack_public_path__ + "img/主页图片1-tuya.4d898419.png";